// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag--2D7H_"};